import { ChangeEvent, Dispatch, FC, SetStateAction, useState } from 'react';
import {
  Grid,
  TextField,
  InputAdornment,
  Typography,
  Chip,
} from '@material-ui/core';
import { connect } from 'react-redux';
import frLocale from 'date-fns/locale/fr';
import DateFnsUtils from '@date-io/date-fns';
import { injectIntl, IntlShape } from 'react-intl';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import {
  EXPERTISE_MEDICAL_ID,
  EXPERTISE_ACCOUNTING_ID,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ExpertRapportDocument from 'containers/ExpertExpertise/ConcernedExpertise/ExpertRapportDocument';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { translate } from 'containers/services/translate';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import { COLORS } from 'constants/design';
import { StyledGrid } from 'containers/ExpertExpertise/FillExpertise/style';
import messages from 'containers/ExpertExpertise/FillExpertise/messages';
import CustomSelect from 'containers/ExpertExpertise/FillExpertise/CustomSelect';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import Document from 'components/Document';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import AccountingExpertiseForm from 'containers/ExpertExpertise/FillExpertise/AccountingExpertiseForm';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { get, isNil } from 'lodash';
import { Expertise } from 'containers/ExpertExpertise/ConcernedExpertise/typings';
import { VictimType } from 'typings/globalTypes';
import { arrayTranslate } from 'containers/services/translate';
import { displayErrorText } from 'containers/services/validateForm';
import { convertNumberToString } from 'containers/ExpertExpertise/FillExpertise/utils';
import {
  DOCUMENT,
  MISSION_EXPERISE_VICTIM_STATUS,
  MISSION_POSTPONE_STATUS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';
import { getEvaluationConfigFields } from 'containers/ExpertExpertise/FillExpertise/utils';
import { TvictimExpertise } from 'containers/common/LegalProceedings/ExpertReport/typings';
import DeceasedVictimForm from 'containers/ExpertExpertise/FillExpertise/DeceasedVictimForm';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import { handleOpenDocument } from 'services/utils';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import MechanicExpertiseForm from 'containers/ExpertExpertise/FillExpertise/MechanicExpertiseForm';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';
import { isTransactionMission } from 'containers/CourtManagerAssignedExpertise/utils';
export interface FillExpertiseProps {
  intl: IntlShape;
  title: string;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  setDocumentId: Function;
  uploadedDocument: IUploadedDocument;
  documentId: string;
  documentIdStore: string;
  formBody: Expertise;
  setFormBody: Dispatch<SetStateAction<Expertise>>;
  document: JudgementOnMeritsDoc;
  setDocument: Dispatch<SetStateAction<JudgementOnMeritsDoc>>;
  victim: VictimType;
  validateExpertise: any;
  validateDocumentExpertise: any;
  isReadOnly?: boolean;
  thirdPartyAppealsItems: any;
  pretiumDolorisItems: any;
  aestheticDamageWithoutConsequenceItems: any;
  aestheticDamageWithConsequenceItems: any;
  careerPrejudiceItems: any;
  schoolingPrejudiceItems: any;
  listings: any;
  sagis_code: any;
  setFormBodyConsultingExpertise: Function;
  mission: any;
  vehicle: any;
  missionDate: any;
  setMissionDate: Function;
  requestGetDocByDocumentumId: Function;
  claimNumber: string;
  lossDate: Date;
}

const FillExpertise: FC<FillExpertiseProps> = (props): JSX.Element => {
  const {
    uploadDocument,
    resetUploadDocumentStore,
    setDocumentId,
    title,
    uploadedDocument,
    documentId,
    documentIdStore,
    formBody,
    setFormBody,
    document,
    setDocument,
    victim,
    validateExpertise,
    validateDocumentExpertise,
    thirdPartyAppealsItems,
    pretiumDolorisItems,
    aestheticDamageWithoutConsequenceItems,
    aestheticDamageWithConsequenceItems,
    careerPrejudiceItems,
    schoolingPrejudiceItems,
  } = props;

  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    validateExpertise,
    translateArrayErrorMessages(validateExpertise, true),
  );
  const documentError = displayErrorText(
    validateDocumentExpertise,
    translateArrayErrorMessages(validateDocumentExpertise, true),
  );

  const setDoc = (document: CorporealDocument) => {
    if (!document.name && !document.type) {
      setDocument({
        ...document,
        url: document.url,
        response: document.url,
      } as any);

      resetUploadDocumentStore();
    } else if (documentId === documentIdStore) {
      setDocument({
        ...document,
        name: document.name,
        type: document.type,
        url: document.url,
      });
      resetUploadDocumentStore();
    }
  };

  const deleteDoc = () => {
    if (!get(document, 'response', null)) {
      setDocument({ ...document, response: '', url: '' } as any);
    }
    setDocument({ ...document, url: '' });
  };

  const handleChangeText = (fieldName: string) => (
    event: ChangeEvent<{ value: unknown }>,
  ) => {
    setIsInputChanged(false);
    setFormBody({ ...formBody, [fieldName]: event.target.value });
  };
  const handleChangeSelect = (fieldName: string) => (
    event: ChangeEvent<{ value: unknown }>,
  ) => {
    setIsInputChanged(false);
    setFormBody({ ...formBody, [fieldName]: event.target.value });
  };
  const assignement = get(props.mission, 'assignedExperts').find(
    (element: any) => element.expertCode === props.sagis_code,
  );

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const missionDate = moment(theDate as Date).format(DATE_FORMAT);

    props.setMissionDate(missionDate);
  };
  const {
    careerPrejudice,
    schoolingPrejudice,
    aestheticDamageWithConsequence,
    aestheticDamageWithoutConsequence,
    medicalPharmaceuticalFees,
    ipp,
    itt,
    pretiumDoloris,
    thirdPartyAppeal,
  } = getEvaluationConfigFields((formBody as unknown) as TvictimExpertise);

  const renderExpertiseFormByExpertiseType = () => {
    if (Number(props.mission?.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <>
          {get(victim, 'injuryPostKey') === INJURY_POST_DECEASED ? (
            <DeceasedVictimForm {...props} />
          ) : (
            formBody && (
              <CustomAccordion
                title={title}
                textColor={COLORS.ACCORDION_TEXT_BLUE}
                bgColor={COLORS.ACCORDION_BG_BLUE}
                image={expertiseExpertiseIcon}
              >
                <StyledGrid container spacing={3} alignItems="center">
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(messages.victim, props)}
                      items={[
                        {
                          label: `${get(victim, 'firstName', '')} ${get(
                            victim,
                            'lastName',
                            '',
                          )}`,
                          value: 1,
                        },
                      ]}
                      value={1}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      name="medicalPharmaceuticalFees"
                      label={translate(
                        messages.medicalPharmaceuticalFees,
                        props,
                      )}
                      value={formBody.medicalPharmaceuticalFees}
                      onChange={handleChangeText('medicalPharmaceuticalFees')}
                      type="number"
                      fullWidth
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES,
                        ]) &&
                        !isInputChanged &&
                        !medicalPharmaceuticalFees
                      }
                      helperText={
                        !isInputChanged &&
                        !medicalPharmaceuticalFees &&
                        message[
                          VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES
                        ]
                      }
                      InputProps={{
                        disabled: props.isReadOnly,
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      name="itt"
                      label={translate(messages.itt, props)}
                      value={parseInt(formBody.itt as string)}
                      onChange={handleChangeText('itt')}
                      type="number"
                      fullWidth
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.ITT,
                        ]) &&
                        !isInputChanged &&
                        !itt
                      }
                      helperText={
                        !isInputChanged &&
                        !itt &&
                        message[VICTIM_EXPERTISE_FIELDS.ITT]
                      }
                      InputProps={{
                        disabled: props.isReadOnly,
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      name="ipp"
                      label={translate(messages.ipp, props)}
                      value={formBody.ipp}
                      onChange={handleChangeText('ipp')}
                      type="number"
                      fullWidth
                      InputProps={{
                        disabled: props.isReadOnly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {translate(messages.expertReportpourcentage, props)}
                          </InputAdornment>
                        ),
                      }}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.IPP,
                        ]) &&
                        !isInputChanged &&
                        !ipp
                      }
                      helperText={
                        !isInputChanged &&
                        !ipp &&
                        message[VICTIM_EXPERTISE_FIELDS.IPP]
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        error={
                          !!get(validateExpertise, [
                            VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL,
                          ]) &&
                          !isInputChanged &&
                          !thirdPartyAppeal
                        }
                        shrink={
                          convertNumberToString(formBody.thirdPartyAppeal)
                            ? true
                            : false
                        }
                      >
                        {translate(messages.thirdPartyAppeals, props)}
                      </InputLabel>
                      <Select
                        title={translate(messages.thirdPartyAppeals, props)}
                        value={
                          convertNumberToString(formBody.thirdPartyAppeal)
                            ? convertNumberToString(formBody.thirdPartyAppeal)
                            : null
                        }
                        onChange={handleChangeSelect('thirdPartyAppeal')}
                        disabled={props.isReadOnly}
                        type="number"
                        error={
                          !!get(validateExpertise, [
                            VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL,
                          ]) &&
                          !isInputChanged &&
                          !thirdPartyAppeal
                        }
                      >
                        {thirdPartyAppealsItems.map((element: any) => (
                          <MenuItem value={element.value}>
                            {element.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!get(validateExpertise, [
                        VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL,
                      ]) &&
                        !isInputChanged &&
                        !thirdPartyAppeal && (
                          <FormHelperText className="errorSelect">
                            {
                              message[
                                VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL
                              ]
                            }
                          </FormHelperText>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(messages.pretiumDoloris, props)}
                      items={pretiumDolorisItems}
                      value={formBody.pretiumDoloris}
                      onChange={handleChangeSelect('pretiumDoloris')}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS,
                        ]) &&
                        !isInputChanged &&
                        !pretiumDoloris
                      }
                      errorMessage={
                        message[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS]
                      }
                      disabled={props.isReadOnly}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(
                        messages.aestheticHarmWithoutConsequence,
                        props,
                      )}
                      items={aestheticDamageWithoutConsequenceItems}
                      value={formBody.aestheticDamageWithoutConsequence}
                      onChange={handleChangeSelect(
                        'aestheticDamageWithoutConsequence',
                      )}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE,
                        ]) &&
                        !isInputChanged &&
                        (!(formBody.aestheticDamageWithConsequence != 0)
                          ? !aestheticDamageWithoutConsequence
                          : (!(
                              formBody.aestheticDamageWithConsequence != 0
                            ) as any))
                      }
                      errorMessage={
                        message[
                          VICTIM_EXPERTISE_FIELDS
                            .AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
                        ]
                      }
                      disabled={
                        props.isReadOnly ||
                        ((formBody.aestheticDamageWithConsequence &&
                          !!(
                            formBody.aestheticDamageWithConsequence != 0
                          )) as any)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(
                        messages.aestheticDamageWithConsequence,
                        props,
                      )}
                      items={aestheticDamageWithConsequenceItems}
                      value={formBody.aestheticDamageWithConsequence}
                      onChange={handleChangeSelect(
                        'aestheticDamageWithConsequence',
                      )}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE,
                        ]) &&
                        !isInputChanged &&
                        (!(formBody.aestheticDamageWithoutConsequence != 0)
                          ? !aestheticDamageWithConsequence
                          : (!(
                              formBody.aestheticDamageWithoutConsequence != 0
                            ) as any))
                      }
                      errorMessage={
                        message[
                          VICTIM_EXPERTISE_FIELDS
                            .AESTHETIC_DAMAGE_WITH_CONSEQUENCE
                        ]
                      }
                      disabled={
                        props.isReadOnly ||
                        ((formBody.aestheticDamageWithoutConsequence &&
                          !!(
                            formBody.aestheticDamageWithoutConsequence != 0
                          )) as any)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(messages.careerPrejudice, props)}
                      items={careerPrejudiceItems}
                      value={formBody.careerPrejudice}
                      onChange={handleChangeSelect('careerPrejudice')}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE,
                        ]) &&
                        !isInputChanged &&
                        (!(formBody.schoolingPrejudice != '0')
                          ? !careerPrejudice
                          : (!(formBody.schoolingPrejudice != '0') as any))
                      }
                      errorMessage={
                        message[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE]
                      }
                      disabled={
                        props.isReadOnly ||
                        ((formBody.schoolingPrejudice &&
                          !!(formBody.schoolingPrejudice != '0')) as any)
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      title={translate(messages.schoolingPrejudice, props)}
                      items={schoolingPrejudiceItems}
                      value={formBody.schoolingPrejudice}
                      onChange={handleChangeSelect('schoolingPrejudice')}
                      error={
                        !!get(validateExpertise, [
                          VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE,
                        ]) &&
                        !isInputChanged &&
                        (!(formBody.careerPrejudice != 0)
                          ? !schoolingPrejudice
                          : (!(formBody.careerPrejudice != 0) as any))
                      }
                      errorMessage={
                        message[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE]
                      }
                      disabled={
                        props.isReadOnly ||
                        ((formBody.careerPrejudice &&
                          !!(formBody.careerPrejudice != 0)) as any)
                      }
                    />
                  </Grid>
                  {isNil(get(props.mission, 'missionDate')) && (
                    <Grid item>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={frLocale}
                      >
                        <KeyboardDatePicker
                          autoOk
                          variant="inline"
                          invalidDateMessage=""
                          format="dd/MM/yyyy"
                          id="lossDate"
                          onChange={handleDateChange}
                          name={'mission-date'}
                          value={dateStringToLocalDate(props.missionDate)}
                          label={translate({ ...messages.missionDate }, props)}
                          error={props.missionDate === 'Invalid date'}
                          helperText={
                            props.missionDate === 'Invalid date'
                              ? translate(messages.invalidDate, props)
                              : ''
                          }
                          className="input"
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  )}
                  <Grid item xs={4}>
                    <TextField
                      title={
                        assignement?.type ===
                          MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
                        get(formBody, 'createdBy', '') === props.sagis_code
                          ? translate(messages.commentAppreciation, props)
                          : translate(messages.comment, props)
                      }
                      label={
                        assignement?.type ===
                          MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION &&
                        get(formBody, 'createdBy', '') === props.sagis_code
                          ? translate(messages.commentAppreciation, props)
                          : translate(messages.comment, props)
                      }
                      value={formBody.comment}
                      onChange={handleChangeText('comment')}
                      fullWidth
                      InputProps={{
                        disabled: props.isReadOnly,
                      }}
                    />
                  </Grid>
                  {featureService.hasFeature(FEATURES.TRANSACTION) && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          title={translate(
                            messages.certificatDescription,
                            props,
                          )}
                          label={translate(
                            messages.certificatDescription,
                            props,
                          )}
                          value={formBody.certificatDescription}
                          onChange={handleChangeText('certificatDescription')}
                          fullWidth
                          InputProps={{
                            disabled: props.isReadOnly,
                          }}
                          inputProps={{
                            style: {
                              overflowY: 'auto',
                              height: 'auto',
                            },
                          }}
                          rows={6}
                          multiline
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          title={translate(messages.clinicalExamination, props)}
                          label={translate(messages.clinicalExamination, props)}
                          value={formBody.clinicalExamination}
                          onChange={handleChangeText('clinicalExamination')}
                          fullWidth
                          InputProps={{
                            disabled: props.isReadOnly,
                          }}
                          inputProps={{
                            style: {
                              overflowY: 'auto',
                              height: 'auto',
                            },
                          }}
                          rows={6}
                          multiline
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          title={translate(messages.injuryDescription, props)}
                          label={translate(messages.injuryDescription, props)}
                          value={formBody.injuryDescription}
                          onChange={handleChangeText('injuryDescription')}
                          fullWidth
                          InputProps={{
                            disabled: props.isReadOnly,
                          }}
                          inputProps={{
                            style: {
                              overflowY: 'auto',
                              height: 'auto',
                            },
                          }}
                          rows={6}
                          multiline
                        />
                      </Grid>
                    </>
                  )}

                  {get(formBody, 'status') ===
                  MISSION_EXPERISE_VICTIM_STATUS.VALIDATED ? (
                    <Grid item xs={12}>
                      <section>
                        {uploadedDocument && (
                          <div className="support-document-info">
                            <Document
                              name={get(uploadedDocument, 'name', '')}
                              type={get(uploadedDocument, 'type', '')}
                              icon={
                                <VisibilityIcon
                                  className="consult"
                                  onClick={handleOpenDocument(
                                    uploadedDocument as any,
                                    props.requestGetDocByDocumentumId,
                                  )}
                                />
                              }
                            />
                          </div>
                        )}
                      </section>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      {!props.isReadOnly && (
                        <span
                          style={{
                            fontSize: '16px',
                            color: 'red',
                            marginBottom: 23,
                          }}
                        >
                          {translate(
                            { ...messages.documentStampedTitle },
                            props,
                          )}
                        </span>
                      )}
                      <Grid item xs={12}>
                        <UploadDocumentBloc
                          index={0}
                          document={document}
                          resetUploadedDocument={resetUploadDocumentStore}
                          uploadDocument={uploadDocument}
                          uploadedDocument={uploadedDocument}
                          docType={DOCUMENT_TYPES.RAPPORT_CONSEIL}
                          setDocumentId={setDocumentId}
                          docId={documentId}
                          setDocument={setDoc}
                          deleteDoc={
                            !isNil(get(formBody, 'id')) &&
                            (get(formBody, 'status') ===
                              MISSION_EXPERISE_VICTIM_STATUS.PENDING ||
                              get(formBody, 'status') ===
                                MISSION_EXPERISE_VICTIM_STATUS.VALIDATED)
                              ? undefined
                              : props.sagis_code === get(formBody, 'createdBy')
                              ? deleteDoc
                              : undefined
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <div className="error">
                          {documentError?.message[DOCUMENT.NAME]}
                        </div>
                      </Grid>
                    </Grid>
                  )}
                  {featureService.hasFeature(FEATURES.TRANSACTION) &&
                    isTransactionMission(props.mission) && (
                      <Grid item xs={12}>
                        <ExpertRapportDocument
                          victim={props.victim}
                          expertise={formBody}
                          listings={props.listings}
                          claimNumber={props.claimNumber}
                          lossDate={props.lossDate}
                          mission={props.mission}
                        />
                      </Grid>
                    )}
                  {((props.isReadOnly && get(formBody, 'status')) ||
                    get(formBody, 'status') ===
                      MISSION_EXPERISE_VICTIM_STATUS.REJECTED) && (
                    <>
                      <Grid item>
                        <Typography
                          style={{
                            color: COLORS.LIGHT_GREY,
                            fontWeight: 400,
                            fontSize: '13px',
                          }}
                        >
                          {translate(messages.statusTitle, props)}
                        </Typography>
                      </Grid>
                      <Grid item xs={11}>
                        <Chip
                          style={{
                            backgroundColor: renderColor(
                              get(formBody, 'status'),
                            ),
                            color: COLORS.WHITE,
                            fontWeight: 700,
                          }}
                          label={
                            props.sagis_code === get(formBody, 'createdBy') &&
                            get(formBody, 'status') ===
                              MISSION_POSTPONE_STATUS.PENDING_APPRECIATION
                              ? 'En cours'
                              : renderChipLabel(get(formBody, 'status'))
                          }
                        />
                      </Grid>
                    </>
                  )}
                  {(props.isReadOnly &&
                    get(formBody, 'status') &&
                    get(formBody, 'createdBy')) ||
                  get(formBody, 'status') ===
                    MISSION_EXPERISE_VICTIM_STATUS.REJECTED ? (
                    <>
                      <Grid item>
                        <Typography
                          style={{
                            color: COLORS.LIGHT_GREY,
                            fontWeight: 400,
                            fontSize: '13px',
                          }}
                        >
                          {translate(messages.createdByTitle, props)}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          style={{
                            color: COLORS.TEXT_BLACK,
                            fontWeight: 400,
                            fontSize: '13px',
                          }}
                        >
                          {getValueByCode(
                            get(formBody, 'createdBy') as string,
                            get(props.listings, 'intervenants'),
                          )}
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                  {get(formBody, 'decisionComment') && (
                    <>
                      <Grid item>
                        <Typography
                          style={{
                            color: COLORS.LIGHT_GREY,
                            fontWeight: 400,
                            fontSize: '13px',
                          }}
                        >
                          {translate(messages.comment, props) + ':'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          style={{
                            color: COLORS.TEXT_BLACK,
                            fontWeight: 400,
                            fontSize: '13px',
                          }}
                        >
                          {get(formBody, 'decisionComment')}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {get(formBody, 'rejectionReason') &&
                    get(formBody, 'status') ===
                      MISSION_EXPERISE_VICTIM_STATUS.REJECTED && (
                      <>
                        <Grid item>
                          <Typography
                            style={{
                              color: COLORS.LIGHT_GREY,
                              fontWeight: 400,
                              fontSize: '13px',
                            }}
                          >
                            {translate(messages.reason, props) + ':'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            style={{
                              color: COLORS.TEXT_BLACK,
                              fontWeight: 400,
                              fontSize: '13px',
                            }}
                          >
                            {get(formBody, 'rejectionReason')}
                          </Typography>
                        </Grid>
                      </>
                    )}
                </StyledGrid>
              </CustomAccordion>
            )
          )}
        </>
      );
    } else if (
      Number(props.mission?.type) === EXPERTISE_ACCOUNTING_ID &&
      props.victim
    ) {
      return <AccountingExpertiseForm {...props} />;
    } else if (
      Number(props.mission?.type) === EXPERTISE_ACCOUNTING_ID &&
      props.vehicle
    ) {
      return <MechanicExpertiseForm {...props} />;
    } else {
      return <MechanicExpertiseForm {...props} />;
    }
  };
  return <>{renderExpertiseFormByExpertiseType()}</>;
};

const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
};

export default connect(null, mapDispatchToProps)(injectIntl(FillExpertise));
